import { render, staticRenderFns } from "./CmgRewardsExchange.vue?vue&type=template&id=ae329d0c&scoped=true&lang=pug"
import script from "./cmg-rewards-exchange.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-exchange.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExchange.vue?vue&type=style&index=0&id=ae329d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae329d0c",
  null
  
)

export default component.exports